import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getAllowedImageLinksObjects } from 'util/imageUtil';

import { SubTitle } from 'components/common/fontElements';
import { TextButton } from '../../common/buttonsComponents';
import ImagesModal from 'components/Messages/ImagesModal/ImagesModal';
import ThumbnailButton from 'components/common/ThumbnailButton/ThumbnailButton';
import { SHAREPOINT_URL } from '../../../api/apiUrls';
import { SharepointHeaderWrapper, ThumbnailsGrid } from './MessageImages.styles';

const MessageImages = ({ message, isAdmin, avatarUrl, messageOriginalTime, simplrAccountId }) => {
  const [imageObjects, setImageObjects] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    const prepareImageObjects = () => {
      const imageLinkObjects = getAllowedImageLinksObjects(String(message.messageBody));
      if (imageLinkObjects.length > 0) {
        setIsVisible(true);
      }

      const preparedImageObjects = imageLinkObjects.map((imageLinkObj) => prepareImageSrc(imageLinkObj));

      setImageObjects(preparedImageObjects);
    };

    const prepareImageSrc = (imageLinkObj) => {
      return {
        ...imageLinkObj,
        src: `${SHAREPOINT_URL}/fetchFile?fileName=${imageLinkObj.fileName}&simplrAccountId=${simplrAccountId}`,
      };
    };

    prepareImageObjects();
  }, [message, simplrAccountId]);

  const openModal = (index) => {
    setSelectedIndex(index);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  if (isVisible) {
    return (
      <section>
        <SharepointHeaderWrapper>
          <SubTitle>Sharepoint attachments LINK ({imageObjects.length})</SubTitle>
          <TextButton onClick={() => openModal(0)}>LINK</TextButton>
        </SharepointHeaderWrapper>
        <ThumbnailsGrid>
          {imageObjects.map((imageObj, index) => (
            <ThumbnailButton
              key={imageObj.fileName}
              imgSrc={imageObj.src}
              altText={imageObj.fileName}
              className={'small zoom-in'}
              isSelected={false}
              onThumbClick={() => {
                openModal(index);
              }}
            />
          ))}
        </ThumbnailsGrid>
        <ImagesModal
          isOpen={modalIsOpen}
          message={message}
          imageObjects={imageObjects}
          selectedIndex={selectedIndex}
          closeModal={closeModal}
          avatarUrl={avatarUrl}
          isAdmin={isAdmin}
          messageOriginalTime={messageOriginalTime}
          setSelectedIndex={setSelectedIndex}
        />
      </section>
    );
  }

  return null;
};

MessageImages.propTypes = {
  message: PropTypes.object.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  avatarUrl: PropTypes.string.isRequired,
  messageOriginalTime: PropTypes.string.isRequired,
  simplrAccountId: PropTypes.string.isRequired,
};

export default MessageImages;
